import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { timer, fromEvent, merge } from 'rxjs';
import { first } from 'rxjs/operators';
import { polyfillAbortController } from '../polyfill-abort-controller.js';
polyfillAbortController();
export function mergeAbortSignals(signals) {
  var controller = new AbortController();
  if (signals.length === 0) {
    throw Error('Need abort signals to create a merged abort signal');
  }
  if (signals.some(function (signal) {
    return signal.aborted;
  })) {
    controller.abort();
    return controller.signal;
  }
  merge.apply(void 0, _toConsumableArray(signals.map(function (signal) {
    return fromEvent(signal, 'abort');
  }))).pipe(first()).subscribe(function () {
    controller.abort();
  });
  return controller.signal;
}
export var TimedAbortSignal = /*#__PURE__*/function () {
  function TimedAbortSignal(timeout) {
    _classCallCheck(this, TimedAbortSignal);
    var controller = new AbortController();
    this.signal = controller.signal;
    if (timeout <= 0) {
      controller.abort();
      return;
    }
    this._subscription = timer(timeout).subscribe(function () {
      controller.abort();
    });
  }
  _createClass(TimedAbortSignal, [{
    key: "clear",
    value: function clear() {
      var _this$_subscription;
      (_this$_subscription = this._subscription) === null || _this$_subscription === void 0 ? void 0 : _this$_subscription.unsubscribe();
    }
  }]);
  return TimedAbortSignal;
}();